import React, {
  useCallback, useEffect, useRef,
  useState,
} from 'react';
import * as Styles from '../Highlight.styles';
import { Button } from 'gatorcomponents';
import { useResize } from '@/hooks/useResize';
import CounterOffer from '../../CounterOffer';
import { IconAiPencil } from '@/pages/Studio/components/Icons/IconAiPencil';
import { ALL_STUDIO_HIGHLIGHTS_IDS, PRODUCTS_HIGHLIGHT_IDS } from '@/pages/Home/HomeHandler.enum.jsx';
import IconAiPen from '@/pages/Home/media/iconAiPen';

const HighlightContent = ({
  element,
  activeTab,
  setGuideCoordinates,
  setHighLightImageLoaded,
  buttonIsLoading,
  guideOn,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const windowRect = useResize();
  const { width: windowWidth } = windowRect;
  const mobile = windowWidth < 600;
  const elementId = `${element.type}${element.id}`;
  const highlightId = element.id;

  const studioButtonRef = useRef(null);
  const imageRef = useRef(null);

  const handleSetImageLoaded = () => {
    setImageLoaded(true);
    setHighLightImageLoaded(true);
  };

  const updateGuidePositionByButtonRef = useCallback(() => {
    if (studioButtonRef.current && ALL_STUDIO_HIGHLIGHTS_IDS.includes(activeTab)) {
      const {
        top, left, width, height,
      } = studioButtonRef.current.getBoundingClientRect();

      setGuideCoordinates({
        top, left, width, height,
      });
    }
  }, [studioButtonRef, setGuideCoordinates, activeTab]);

  const executeGuideCoordinates = useCallback(() => {
    updateGuidePositionByButtonRef();

    window.addEventListener('resize', updateGuidePositionByButtonRef);

    return () => {
      window.removeEventListener('resize', updateGuidePositionByButtonRef);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageLoaded, guideOn, updateGuidePositionByButtonRef]);

  useEffect(() => {
    executeGuideCoordinates();
  }, [executeGuideCoordinates]);

  return (
    <Styles.DivContents id={elementId} key={elementId} ref={imageRef}>
      {element.image && (
        <Styles.DivImg variant={elementId}>
          <img
            src={element.image}
            alt="produto em destaque"
            onLoad={() => handleSetImageLoaded(true)}
            onError={() => handleSetImageLoaded(true)}
          />
        </Styles.DivImg>
      )}

      <Styles.DivText variant={elementId}>
        {element.tag_name !== null && (
          <Styles.Tag tagColor={element.tag_color}>
            {element.tag_name}
          </Styles.Tag>
        )}
        <Styles.WrapperTitle variant={elementId}>
          <Styles.Title variant={elementId} data-testid={`title-${element.type}`} dangerouslySetInnerHTML={{ __html: element.title }} />
          {(highlightId === PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_PRO_TRIAL || highlightId === PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_PRO)
            && <IconAiPencil />
          }
          {highlightId === PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_FREE
            && <IconAiPen />
          }
        </Styles.WrapperTitle>
        <Styles.Description variant={elementId} data-testid={`description-${element.type}`} dangerouslySetInnerHTML={{ __html: element.description }} />
        {(highlightId === PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_PRO_TRIAL || highlightId === PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_PRO)
          && <CounterOffer element={element} />
        }
        <Styles.ButtonWrapper
          ref={ALL_STUDIO_HIGHLIGHTS_IDS.includes(element.id) ? studioButtonRef : null}
        >
          <Button
            testId="cta"
            label={element.cta.label}
            variant="primary"
            size="xlarge"
            version="v2"
            width={mobile ? 'full' : 'fit-content'}
            onClick={element.cta.onClick}
            loading={buttonIsLoading}
            disabled={buttonIsLoading}
          />
        </Styles.ButtonWrapper>
      </Styles.DivText>
    </Styles.DivContents>
  );
};

export default HighlightContent;
